import React from 'react';
import { Box } from '@mui/material';
import { useShowView } from '@stores/calibrationUIStore';
import type { DatasheetGroup } from '@features/calibration/hooks/useGroupedDatasheet';
import type { CommitMeasurementHandler, RunnerLiveState } from '../types';
import RunnerTabletCard from './RunnerTabletCard';

type RunnerMobileListProps = {
  group: DatasheetGroup;
  readOnly?: boolean;
  liveState?: RunnerLiveState;
  runId?: string;
  sideBySide?: boolean;
  onCommitMeasurement?: CommitMeasurementHandler;
};

const RunnerMobileList: React.FC<RunnerMobileListProps> = ({
  group,
  readOnly = false,
  liveState,
  runId,
  sideBySide = false,
  onCommitMeasurement
}) => {
  const showView = useShowView();
  const showAsFound = showView === 'all' || showView === 'asFound';
  const showAsLeft = showView === 'all' || showView === 'asLeft';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {group.points.map(point => (
        <RunnerTabletCard
          key={point.id}
          point={point}
          unit={group.unit}
          showAsFound={showAsFound}
          showAsLeft={showAsLeft}
          readOnly={readOnly}
          isCurrentPoint={liveState?.currentPointId === point.id}
          landedSide={
            liveState?.landedPointId === point.id ? liveState.landedSide : null
          }
          landedAt={
            liveState?.landedPointId === point.id ? liveState.landedAt : null
          }
          runId={runId}
          compact={!sideBySide}
          onCommitMeasurement={onCommitMeasurement}
        />
      ))}
    </Box>
  );
};

export default RunnerMobileList;
